const release = require('../gas/release')
const log = require('./log')

exports.start = start
